<template>
    <div>
        <form class="pl-3" @submit.prevent="submitUserOutlet">
            <h6 class="mt-3 mb-3 text-secondary fw-300">{{$t('user.header_sub_outlet_add', {'user': username})}}</h6>
            <div class="row">
                <div  class="col">
                    <div class="demo">
                        <button v-for="o in outlet" :key="o.outletID" type="button" class="btn btn-lg btn-outline-primary waves-effect waves-themed text-left fs-sm">
                            <div class="custom-control custom-checkbox mb-1" style="margin-left: -1em;">
                                <input type="checkbox" class="custom-control-input" :id="'cbx_outlet_' + o.outletID" v-model="hasOutlet[o.outletID]">
                                <label class="custom-control-label" :for="'cbx_outlet_' + o.outletID"></label>
                            </div>
                            <span class="d-block"><i class="fas fa-user mr-2"></i>{{o.username}}</span>
                            <span class="d-block border-top pt-1 mt-1"><i class="fas fa-store-alt mr-2"></i>{{o.bizName == "" ? "-" : o.bizName}}</span>
                            <span class="d-block border-top pt-1 mt-1"><i class="fas fa-location mr-2"></i>{{o.location == "" ? "-" : o.location}}</span>
                            <span class="d-block border-top pt-1 mt-1"><i class="fas fa-map-marker-alt mr-2"></i>{{o.city == "" ? "-" : o.city}}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="text-left mt-3">
                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
            </div>
        </form>
    </div>
</template>
<script>
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'userOutletForm',
    props:{
        userOutlet: {type: Array},
        userID: {type: Number},
        username: {type : String}
    },
    data(){
        return{
            outlet: []
        }
    },
    computed:{
        hasOutlet(){
            var ret = {};
            for(var i=0; i<this.userOutlet.length; i++){
                for(var j=0; j<this.outlet.length; j++){
                    if(this.outlet[j].outletID == this.userOutlet[i].outletID){
                        ret[this.outlet[j].outletID] = true;
                    }
                }
            }
            return ret
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.$emit('resetOutletList')
            }
            this.$parent.$parent.$parent.$parent.isModalShow = false;
        },
        getOutlet(){
            let $vm = this
            $vm.$axios({
                method: 'get', 
                url: $vm.$api.OUTLET,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.outlet = response.data.outlets
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        submitUserOutlet(){
            let $vm = this
            const url = $vm.$api.USER + "/" + this.userID + this.$api.USER_OUTLET + this.$api.UPDATE
            
            var data = []
            for(var id in this.hasOutlet){
                if(this.hasOutlet[id]){
                    data.push(parseInt(id))
                }
            }
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: {
                    outletID: data
                }
            })
            .then(function(response) {
                if(response.status == 200){
                    var message = $vm.$i18n.t('user.user_outlet') + $vm.$i18n.t('message.success.update')
                    $vm.$parent.$parent.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
    },
    mounted(){
        let $vm = this;
        $vm.getOutlet();
    },
}
</script>
<style scoped>
.btn-outline-primary:hover{
    color: #886ab5 !important;
    background-color: #f2eef7 !important;
    border-color: #886ab5 !important;

}
</style>